export default __webpack_public_path__ + "static/media/delivery23yellow.586c6adc.svg";